






























import { Component, Prop, Vue } from 'vue-property-decorator';
import CoinIcon from '@/components/icons/WidgetCoin.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import flagKeys from '@/constants/flagKeys';
import { getBillingIsHidden } from '@/utils/billing';

@Component({
  components: {
    CoinIcon,
    Typography
  }
})
export default class BillingNetworkTag extends Vue {
  @Prop({ default: '' }) featureName!: string;

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get slug() {
    return this.featureName
      .toLocaleLowerCase()
      .split(' ')
      .join('-');
  }

  get isNotFeature() {
    const notFeatureRoutes = ['/coin-network-plan'];

    return notFeatureRoutes.includes(this.$route.path);
  }

  // Guarded at the root so the five page-title call sites need no change of their
  // own, and so the empty container never survives to leave a stray flex gap next
  // to the title (TWISM-19008).
  get billingIsHidden() {
    return getBillingIsHidden();
  }

  get showBillingTag() {
    return this.flags.includes(flagKeys.billingModuleV2);
  }
}
